import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToHash } from '../lib/scrollToHash.js';

// Bei Route-Wechsel nach oben scrollen – außer es gibt einen Hash (#section),
// dann zu diesem Anker. Muss innerhalb von <BrowserRouter> leben.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Warten bis das DOM der neuen Route gerendert ist
      const t = setTimeout(() => scrollToHash(hash), 0);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);

  return null;
}
